<template>
  <div>
    <b-form-input
      v-model="title.val"
      class="input-question"
      type="text"
      :state="title.valid"
      :disabled="loading"
      required
      placeholder="Escribe titulo de tu pregunta"
    ></b-form-input>
    <b-form-textarea
      :state="question.valid"
      :disabled="loading"
      class="input-question mt-3"
      v-model="question.val"
      placeholder="Escribe tu pregunta..."
      rows="3"
      max-rows="6"
    ></b-form-textarea>
    <b-button @click="cancel" style="float:left" :disabled="loading" class="mt-3 b-light">
      <i class="fas fa-arrow-left"></i> Volver
    </b-button>
    <b-button @click="sendQuestion" style="float:right" :disabled="loading" class="mt-3 b-yellow">
      <b-spinner v-if="loading" small></b-spinner>
      <i v-if="!loading" class="fas fa-save"></i> Guardar
    </b-button>
  </div>
</template>

<script>
export default {
  props: {
    questionInfo: Object
  },
  data() {
    return {
      loading: false,
      title: {
        val: "",
        valid: null
      },
      question: {
        val: "",
        valid: null
      }
    };
  },
  created() {
    this.title.val = this.questionInfo.title;
    this.question.val = this.questionInfo.question;
  },
  methods: {
    verifyInputs() {
      let title = this.title.val.trim();
      let question = this.question.val.trim();

      if (title != "" && title != null && title != undefined) {
        this.title.valid = true;
      } else {
        this.title.valid = false;
      }

      if (question != "" && question != null && question != undefined) {
        this.question.valid = true;
      } else {
        this.question.valid = false;
      }
    },
    sendQuestion() {
      this.loading = true;
      this.verifyInputs();
      if (this.title.valid && this.question.valid) {
        let url =
          "course/" +
          this.questionInfo.curse_id +
          "/question/" +
          this.questionInfo.id;
        this.api
          .put(url, {
            data: {
              title: this.title.val,
              question: this.question.val
            }
          })
          .then(({ data }) => {
            this.loading = false;
            if (data.updating) {
              this.bus.$emit("UpdateQuestion", {
                question: this.question.val,
                title: this.title.val
              });
              this.bus.$emit("UpdateQuestions", data.data_return);
              this.title = {
                val: "",
                valid: null
              };
              this.question = {
                val: "",
                valid: null
              };
            }
          })
          .catch(err => {
            this.loading = false;
            console.log(err);
          });
      } else {
        this.loading = false;
      }
    },
    cancel() {
      this.bus.$emit("CancelEditQuestion", false);
    }
  }
};
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/components/#public/curse/components/content/EditQuestion.vue